<script setup lang="ts">
import{PhCheckCircle as CheckCircle,PhWarningCircle as WarningCircle}from'@phosphor-icons/vue';import{useFeedback}from'../feedback';
const feedback=useFeedback();
</script>

<template><div class="toast-host" aria-live="polite" aria-atomic="true"><button v-for="message in feedback.messages" :key="message.id" class="toast-message" :class="message.kind" type="button" @click="feedback.remove(message.id)"><CheckCircle v-if="message.kind==='success'" :size="21"/><WarningCircle v-else :size="21"/><span>{{message.text}}</span></button></div></template>
